// extracted by mini-css-extract-plugin
module.exports = {"Header":"App_Header__ZS1m2","Footer":"App_Footer__XLEFd","Left":"App_Left__3Xz_y","Right":"App_Right__jRely","Center":"App_Center__g2mar"};